import { render, staticRenderFns } from "./LegalExpertClaims.vue?vue&type=template&id=7c022d54&scoped=true"
import script from "./LegalExpertClaims.vue?vue&type=script&lang=js"
export * from "./LegalExpertClaims.vue?vue&type=script&lang=js"
import style0 from "./LegalExpertClaims.vue?vue&type=style&index=0&id=7c022d54&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c022d54",
  null
  
)

export default component.exports